'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "RootNavigationStateContext", {
    enumerable: true,
    get: function() {
        return RootNavigationStateContext;
    }
});
function _react() {
    const data = require("react");
    _react = function() {
        return data;
    };
    return data;
}
const RootNavigationStateContext = /*#__PURE__*/ (0, _react().createContext)(undefined);

//# sourceMappingURL=RootNavigationStateContext.js.map
